import { putRefundTransaction, SuccessResponse } from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { handleNotAuthorized, Self } from '../common';

function* refundTransactionRequest(
  self: Self,
  txID: string
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield putRefundTransaction(txID);
    const { status } = (response as SuccessResponse).data;
    if (status.code === 1000) {
      return Promise.resolve('OK');
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    return Promise.resolve(status.messages[0]);
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default refundTransactionRequest;
